import React from 'react';
import { Helmet } from 'react-helmet';
import CssHeader from './CssHeader';
import Header from './Header';
import Footer from './Footer';
import IncludeSidebar from './IncludeSidebar';
import IncludeMariigeCertificate from "./IncludeMariigeCertificate";

function Thanks() {
	return (
		<>
		  <Helmet>
			<title>Court Marriage</title>
			<meta name="description" content="Court Marriage." />
			<meta name="keywords" content="Delhi Court Marriage" />
		  </Helmet>
		  <CssHeader />
		  <Header />
		  <div id="main" className="site-main hfeed site">
			<div id="main-content" className="main-content">
			  <div id="primary" className="content-area">
				<div id="content" className="site-content" role="main">				 
				
					<div id="post-52" className="post-52 page type-page status-publish hentry">
						<header class="entry-header">
							<h1 class="entry-title">Thanks</h1>
						</header>
						<div class="entry-content">
							<div class="fl-callout-content">
								<p class="fl-callout-title">
									<span class="fl-callout-title-text">Thanks for submit the form. Our team will contact you soon.</span>
								</p>
								
							</div>
						</div>
					</div>
					
				</div>
			  </div>
			  <IncludeSidebar/>
			</div>
			<IncludeMariigeCertificate/>
		  </div>
		  <Footer />
		</>
	  );
	}
	

export default Thanks;
